<template>
<div v-if="isMobileMode()">
            <div class="display-1 font-weight-black orange--text text-xs-center">ICRON LIVE</div>
            <div class="font-weight-bold white--text text-xs-center" style="background-color: black">
                Sistema di monitoraggio di eventi sportivi.
            </div>
    <!-- v-img style="height: 100px" :src="items[0].src" / -->
     <v-carousel hide-delimiters style="height: 150px; width: 100%" :show-arrows="false">
        <v-carousel-item v-for="(item,i) in itemsMobile" :key="i" :src="item.src" style="height: 150px; width: 100%"> 
        </v-carousel-item>
    </v-carousel>
</div>
<div v-else>
     <v-carousel hide-delimiters style="height: 400px" :show-arrows="false">
        <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src">
            <div class="display-4 font-weight-black orange--text text-xs-center">ICRON LIVE</div>
            <div class="display-1 font-weight-bold white--text text-xs-center" style="background-color: black">
                 Sistema di monitoraggio di eventi sportivi.
            </div>
        </v-carousel-item>
    </v-carousel>
</div>
</template>

<script>
export default {
    name: 'HomeHero',
    data() {
        return {
            items: [{
                    src: 'https://www.icron.it/live/assets/images/marcia.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/tri.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/porsche.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/aqua.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/inferno.jpg',
                }
            ],

              itemsMobile: [{
                    src: 'https://www.icron.it/live/assets/images/marcia_mobile.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/tri_mobile.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/porsche_mobile.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/aqua_mobile.jpg',
                },
                {
                    src: 'https://www.icron.it/live/assets/images/inferno_mobile.jpg',
                }
            ],
        }
    },
};
</script>
